import { Box, BoxProps } from '@chakra-ui/react';

interface RequiredFieldLabelProps extends BoxProps {
  children: React.ReactNode;
}

export const RequiredFieldLabel = ({ children, ...props }: RequiredFieldLabelProps) => (
  <Box fontSize="16px" {...props}>
    <Box as="span" color="red.500" aria-hidden="true">
      *{' '}
    </Box>
    {children}
  </Box>
);
